/* istanbul ignore file */

const OS_MAP = {
  OSX: 'Mac OS',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
  IOS: 'iOS',
  ANDROID: 'Android'
}

export function getUserAgent() {
  return window.navigator.userAgent
}

export function getOS() {
  const userAgent = getUserAgent()?.toLowerCase()
  let os = null

  const isIOS =
    (/ipad|iphone|ipod/.test(userAgent) ||
      (/mac|mac os|macintel/gi.test(userAgent) &&
        (navigator.maxTouchPoints > 1 || 'ontouchend' in document))) &&
    !window.MSStream

  if (
    !isIOS &&
    /macintosh|mac|mac os|macintel|macppc|mac68k/gi.test(userAgent)
  ) {
    os = OS_MAP.OSX
  } else if (isIOS) {
    os = OS_MAP.IOS
  } else if (/'win32|win64|windows|windows nt|wince/gi.test(userAgent)) {
    os = OS_MAP.WINDOWS
  } else if (/android|webos/gi.test(userAgent)) {
    os = OS_MAP.ANDROID
  } else if (/linux/gi.test(userAgent)) {
    os = OS_MAP.LINUX
  }

  return os
}

export function isMacOS() {
  return getOS() === OS_MAP.OSX
}

export function isWindows() {
  return getOS() === OS_MAP.WINDOWS
}

export function isLinux() {
  return getOS() === OS_MAP.LINUX
}

export function isIOS() {
  return getOS() === OS_MAP.IOS
}

export function isAndroid() {
  return getOS() === OS_MAP.ANDROID
}

export function isSafari() {
  return /apple/i.test(navigator.vendor.toLowerCase())
}

export function isFirefox() {
  const userAgent = getUserAgent()?.toLowerCase()
  return userAgent.indexOf('firefox') != -1
}

export function isMobile() {
  return isIOS() || isAndroid()
}
